module.exports = __webpack_public_path__ + "static/media/envelopeActive.ab59daf8.svg";